import React, { createContext, useReducer, useEffect } from 'react';
import { Auth } from 'aws-amplify';


export const LocationContext = createContext();

const initialState = {
    country: null,        // e.g., "IN"
    countryCode: null,    // e.g., "IN", "US"
    gateway: null,        // "razorpay" or "stripe"
    loading: true,
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_COUNTRY':
            return {
                ...state,
                country: action.payload.country_code,   // country_name not available, so fallback
                countryCode: action.payload.country_code,
                gateway: action.payload.gateway,
                loading: false,
            };
        case 'ERROR':
            return { ...state, loading: false };
        default:
            return state;
    }
};

export const LocationProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const fetchCountry = async () => {
        const getToken = async () => {
            try {
                const user = await Auth.currentAuthenticatedUser();
                const session = await Auth.currentSession();
                const jwt = session.getIdToken().getJwtToken();
                return jwt;
            } catch (error) {
                //console.error("Auth error:", error); // Add this line for debugging
                await Auth.signOut();
                return null;
            }
        };

        const jwt = await getToken();
        //console.log("JWT Token:", jwt); // Debugging line to check JWT
        if (!jwt) {
            dispatch({ type: 'ERROR' });
            return;
        }

        try {
            const res = await fetch("https://api.dev.quizwizard.net/quiz/paymentgateway", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${jwt}`
                },
            });
            const data = await res.json();

            if (data && data.country_code) {
                dispatch({ type: 'SET_COUNTRY', payload: data });
            } else {
                dispatch({ type: 'ERROR' });
            }
        } catch (error) {
            //console.error("Location fetch failed:", error);
            dispatch({ type: 'ERROR' });
        }
    };

    useEffect(() => {
        fetchCountry();
    }, []);

    return (
        <LocationContext.Provider value={state}>
            {children}
        </LocationContext.Provider>
    );
};
